export const EVENT_CHECKIN = `
	query eventCheckIn($event_id: Uint) {
		eventCheckIn(event_id: $event_id) {
			id
			active
			settings
		}
	}
`;
